<template>
  <b-container class="mw-100 mt-3">
    <b-card class="mt-4 mb-4" :body-class="isMobile ? 'p-2' : ''">
      <standard-table ref="penaltyChargeNotice"
                      :items="items"
                      :fields="fields"
                      :search-place-holder="`${$tc('message.example', 1)}: AA999ZZ`"
                      :custom-fields="customFields"
                      :row-before-search="{cols: 12,sm: 12,md: 12,lg: 2,xl: 2,order: 3,orderSm: 1,orderMd: 1,orderLg: 3,orderXl: 3}"
                      :row-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"
                      :row-after-search="{cols: 12, sm: 12, md: 12, lg: 6, xl: 6, order: 2, orderSm: 3, orderMd: 3, orderLg: 2, orderXl: 2}"
                      :after-search="{cols: 12, sm: 12, md: 12, lg: 12, xl: 12}"
                      :row-pagination="{cols: 12, sm: 12, md: 6, lg: 5, xl: 5}"
                      :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 4}"
                      :row-per-page="{cols: 12, sm: 12, md: 5, lg: 3, xl: 2}"
                      :row-after-per-page="{cols: 12, sm: 12, md: 12, lg: 3, xl: 1}"
                      :empty-text="`${$tc('message.courtesyMessageTable', 1)}`"
                      fullWidth="true"
                      v-on:perPage="perPages = $event; currentPage = 0; items = []; fetchData()"
                      v-on:currentPage="items.length > 0 ? fetchData() : null"
                      noContainerPadding="true"
                      @rowEdit="pushToEdit($event.item)">

        <template slot="stato" slot-scope="row">
          <b-row style="justify-content: space-between">
            <font-awesome-icon v-if="row.item.statoVerifica === 'NON_ACCETTATA'"
                               size="2x"
                               v-b-popover.hover.top="'Stato verifica: non accettata'"
                               style="transform: rotate(45deg)"
                               icon="plus-circle" class="c-green"/>
            <font-awesome-icon v-if="row.item.statoVerifica === 'ACCETTATA'"
                               v-b-popover.hover.top="'Stato verifica: accettata'"
                               size="2x"
                               icon="check-circle" class="c-green"/>
            <font-awesome-icon v-if="row.item.statoVerifica === 'DA_VERIFICARE'"
                               v-b-popover.hover.top="'Stato verifica: da verificare'"
                               size="2x"
                               icon="question-circle" class="c-green"/>

            <font-awesome-icon v-if="row.item.statoContestazione === 'ESEGUITO'"
                               size="2x" icon="balance-scale"
                               v-b-popover.hover.top="'Stato contestazione: eseguita'"
                               class="c-green"/>
            <font-awesome-icon v-if="row.item.statoContestazione === 'NON_ESEGUITO'"
                               size="2x"
                               v-b-popover.hover.top="'Stato contestazione: non eseguita'"
                               icon="balance-scale" class="c-grey"/>

            <inline-svg :id="row.item.id" v-if="row.item.statoRimborso === 'RICHIESTO'"
                        height="2.1rem" width="2.2rem"
                        v-b-popover.hover.top="'Stato rimborso: richiesto'"
                        :src="mySVG" fill="#249a80"/>
            <inline-svg  v-else-if="row.item.statoRimborso === 'NON_RICHIESTO'"
                         height="2.1rem" width="2.2rem"
                         v-b-popover.hover.top="'Stato rimborso: non richiesto'"
                         :src="mySVG" fill="darkgrey"/>

            <font-awesome-icon v-if="row.item.statoPagamento === 'ESEGUITO'"
                               v-b-popover.hover.top="'Stato pagamento: eseguito'"
                               size="2x" icon="euro-sign" class="c-green mr-3"/>
            <font-awesome-icon v-if="row.item.statoPagamento === 'NON_ESEGUITO'"
                               v-b-popover.hover.top="'Stato pagamento: non eseguito'"
                               size="2x" icon="euro-sign" class="c-grey mr-3"/>

          </b-row>
        </template>
        <b-container slot="row-before-search" class="mw-100 p-0">
          <b-row align-h="end">
            <b-col cols="auto">
              <!-- config[crud], create - read - update - delete -->
              <b-button v-on:click="pushToEdit()" class="b-c-blue mb-3" id="add-penalty-charge-notice" v-if="config.c">
                {{$t('message.add')}}
              </b-button>
            </b-col>
          </b-row>
        </b-container>
        <b-container :body-class="isMobile ? 'p-2' : ''" slot="row-after-search" class="mw-100 p-0 ">
          <b-row>
            <b-col cols="auto">
              <b-button v-on:click="resetFilters()" class="b-c-green" id="reset-filters">
                {{$t('message.resetFilters')}}
              </b-button>
            </b-col>

            <b-col cols="auto" class="mb-3">
              <b-button @click="showCollapse = !showCollapse" :class="showCollapse ? 'b-c-red' : 'b-c-green'">
                <span v-show="!showCollapse" class="when-opened">{{$t('message.show')}} {{$tc('message.filter', 2).toLowerCase()}}</span>
                <span v-show="showCollapse" class="when-closed">{{$t('message.hide')}} {{$tc('message.filter', 2).toLowerCase()}}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-container>

        <b-container :body-class="isMobile ? 'p-2' : ''" slot="after-search" class="mw-100 p-0">
          <b-collapse id="my-collapse" v-model="showCollapse">
            <b-container class="mw-100 m-0 p-0">
              <b-row>
                <b-col cols="12" sm="12" md="2" lg="2" xl="2">
                  <b-form-group :label="`${$tc('message.numberPlate', 1)}`"
                                label-for="input-number-plate">
                    <b-form-input id="input-number-plate"
                                  v-model="plateFilter"
                                  autocomplete="off" type="text"
                                  :placeholder="`${$tc('message.example', 1)}: GH4560PO`">
                    </b-form-input>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="3" lg="3" xl="3">
                  <b-form-group :label="`${$tc('message.period', 1)} ${$tc('message.from', 1).toLowerCase()}`"
                                label-for="input-date-from">
                    <b-input-group>
                      <flat-pickr id="input-date-from"
                                  :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                                  class="form-control"
                                  v-model="fromFilter"
                      >
                      </flat-pickr>
                      <div class="input-group-append">
                        <b-button @click="fromFilter = null"
                                  :disabled="!fromFilter">
                          <font-awesome-icon icon="trash"/>
                        </b-button>
                      </div>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="3" lg="3" xl="3">
                  <b-form-group :label="`${$tc('message.to', 1).toLowerCase()}`"
                                label-for="input-date-to">
                    <b-input-group>
                      <flat-pickr id="input-date-to"
                                  :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                                  class="form-control"
                                  v-model="toFilter"
                      >
                      </flat-pickr>
                      <div class="input-group-append">
                        <b-button @click="toFilter = null"
                                  :disabled="!toFilter">
                          <font-awesome-icon icon="trash"/>
                        </b-button>
                      </div>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="12" md="4" lg="4" xl="4">
                  <b-card>
                    <b-form-group label-cols="4" :label="`${$tc('message.status', 1)} ${$tc('message.practice', 1).toLowerCase()}`"
                                  label-for="violation-status">
                      <div class="mt-2">
                        <b-row style="justify-content: space-around">
                          <font-awesome-icon v-b-popover.hover.top="'Clicca per scegliere uno stato verifica'" size="2x" @click="verificationFilter = 1" v-if="verificationFilter === null" icon="check-circle" class="c-grey"/>
                          <font-awesome-icon v-b-popover.hover.top="'Stato verifica: accettata'" size="2x" @click="verificationFilter = 1" v-if="verificationFilter === 0" icon="check-circle" class="c-green"/>
                          <font-awesome-icon v-b-popover.hover.top="'Stato verifica: non accettata'" size="2x" @click="verificationFilter = 2" v-if="verificationFilter === 1" icon="plus-circle" style="transform: rotate(45deg)" class="c-green"/>
                          <font-awesome-icon v-b-popover.hover.top="'Stato verifica: da verificare'" size="2x" @click="verificationFilter = 0" v-if="verificationFilter === 2" icon="question-circle" class="c-green"/>

                          <font-awesome-icon v-b-popover.hover.top="disputeFilter ? 'Stato contestazione: eseguita' : disputeFilter === null ? 'Clicca per scegliere uno stato contestazione' : 'Stato contestazione: non eseguita'"
                                             size="2x" @click="disputeFilter = !disputeFilter"
                                             :class="disputeFilter ? 'c-green' : 'c-grey'"
                                             icon="balance-scale" />
                          <font-awesome-icon v-b-popover.hover.top="paymentFilter ? 'Stato pagamento: eseguito' : paymentFilter === null ? 'Clicca per scegliere uno stato pagamento' : 'Stato pagamento: non eseguito'"
                                             size="2x" @click="paymentFilter = !paymentFilter"
                                             :class="paymentFilter ? 'c-green' : 'c-grey'" icon="euro-sign"/>
                          <inline-svg height="2.1rem" width="2.2rem" class="mb-0 mt-0"
                                      v-b-popover.hover.top="refundFilter ? 'Stato rimborso: richiesto' : refundFilter === null ? 'Clicca per scegliere uno stato rimborso' : 'Stato rimborso: non richiesto'"
                                      @click="refundFilter = !refundFilter"
                                      :class="refundFilter ? 'c-green' : 'c-grey'" :src="mySVG"
                                      :fill="refundFilter
                                ? '#249a80' : 'darkgrey'"/>
                        </b-row>
                      </div>
                    </b-form-group>
                  </b-card>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="$t('message.driver')"
                                label-for="input-driver-name">
                    <model-list-select id="input-driver-name"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="driverDetailedOptions && driverDetailedOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="driverIdFilter"
                                       :list="driverDetailedOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-container>
          </b-collapse>
        </b-container>
      </standard-table>
    </b-card>
  </b-container>

</template>

<script>
import Vue from 'vue'
import { DateTime } from 'luxon'

const axios = require('axios')

export default {
  name: 'PenaltyChargeNotice',
  data () {
    const config = this.$route.meta.config
    const BASE_URL_PENALTY_CHARGE_NOTICE = Vue.getBaseUrlPenaltyChargeNotice()
    return {
      DateTime,
      BASE_URL_PENALTY_CHARGE_NOTICE,
      config,
      isMobile: false,
      items: [],
      fields: [
        { key: 'edit', label: '', sortable: false },
        { key: 'id', label: this.$tc('message.violationID'), sortable: true },
        { key: 'numeroVerbale', label: this.$tc('message.verbalNumber') },
        { key: 'dataInfrazione', label: this.$tc('message.date', 1), sortable: true },
        { key: 'targa', label: this.$tc('message.numberPlate', 1), sortable: true },
        { key: 'importo', label: this.$tc('message.penaltyChargeNoticeAmount', 1), sortable: true },
        { key: 'scadenza', label: this.$tc('message.paymentDeadline', 1), sortable: true },
        { key: 'importoRidotto', label: this.$tc('message.reducedAmount', 1), sortable: true },
        { key: 'scadenzaRiduzione', label: this.$tc('message.reducedPaymentDeadline', 1), sortable: true },
        { key: 'stato', label: this.$tc('message.status', 1) + ' ' + this.$tc('message.practice', 1) }
      ],
      customFields: [
        { key: 'stato', label: this.$tc('message.status', 1) + ' ' + this.$tc('message.practice', 1) }
      ],
      mySVG: require('../../assets/euro.svg'),
      showCollapse: false,
      plateFilter: '',
      fromFilter: '',
      toFilter: '',
      paymentFilter: null,
      disputeFilter: null,
      refundFilter: null,
      verificationFilter: null,
      driverIdFilter: '',
      driverDetailedOptions: [],
      driverOptions: [],
      perPages: 10,
      currentPage: 0,
      filtered: false
    }
  },
  created () {
    this.fetchData()
  },
  watch: {
    plateFilter () {
      this.currentPage = 0
      this.items = []
      this.fetchData()
    },
    fromFilter () {
      if (this.fromFilter !== '') {
        this.currentPage = 0
        this.items = []
        this.fetchData()
      }
    },
    toFilter () {
      if (this.toFilter !== '') {
        this.currentPage = 0
        this.items = []
        this.fetchData()
      }
    },
    driverIdFilter () {
      if (this.driverIdFilter !== '') {
        this.currentPage = 0
        this.items = []

        this.fetchData()
      }
    },
    paymentFilter () {
      this.currentPage = 0
      this.items = []
      this.fetchData()
    },
    verificationFilter () {
      this.currentPage = 0
      this.items = []
      this.fetchData()
    },
    refundFilter () {
      this.currentPage = 0
      this.items = []
      this.fetchData()
    },
    disputeFilter () {
      this.currentPage = 0
      this.items = []
      this.fetchData()
    }
  },
  methods: {
    pushToEdit (item) {
      item && item.id ? this.$router.push({
        name: 'EditPenaltyChargeNotice', params: { id: item.id }
      }) : this.$router.push({
        name: 'EditPenaltyChargeNotice', params: { id: 'new' }
      })
    },
    urlForm () {
      const session = Vue.getLocalStorage('session')
      const token = session && session.token
      let url = `${this.BASE_URL_PENALTY_CHARGE_NOTICE}/violazione?`
      if (this.plateFilter !== '') {
        url = url + 'targa=' + this.plateFilter + '&'
      }
      if (this.fromFilter !== '') {
        url = url + 'dataInizio=' + new Date(this.fromFilter).toISOString() + '&'
      }
      if (this.toFilter !== '') {
        url = url + 'dataFine=' + new Date(this.toFilter).toISOString() + '&'
      }
      if (this.driverIdFilter !== '') {
        url = url + 'idAutista=' + this.driverIdFilter + '&'
      }
      if (this.paymentFilter !== null && this.showCollapse) {
        url = url + 'pagamento=' + this.getPaymentDisputeFilterString(this.paymentFilter) + '&'
      }
      if (this.refundFilter !== null && this.showCollapse) {
        url = url + 'rimborso=' + this.getRefundFilterString(this.refundFilter) + '&'
      }
      if (this.disputeFilter !== null && this.showCollapse) {
        url = url + 'contestazione=' + this.getPaymentDisputeFilterString(this.disputeFilter) + '&'
      }
      if (this.verificationFilter !== null && this.showCollapse) {
        url = url + 'verifica=' + this.getVerificationFilterString(this.verificationFilter) + '&'
      }
      if (this.perPages !== null) {
        url = url + 'pageSize=' + (parseInt(this.perPages)).toString() + '&'
      }

      if (this.currentPage !== null) {
        url = url + 'page=' + (parseInt(this.currentPage)).toString() + '&'
      }
      return {
        method: 'get',
        url: url,
        headers: {
          Authorization: 'Bearer ' + token
        }
      }
    },
    fetchData () {
      if (this.driverOptions.length === 0) {
        this.getDrivers()
      }
      if (this.items.length > 0) {
        this.currentPage = this.currentPage + 1
        const config = this.urlForm()
        return axios(config).then((response) => {
          const options = this.items
          response.data.risorse.forEach((item) => {
            item.dataInfrazione = DateTime.fromISO(item.dataInfrazione).toFormat('dd/MM/y')
            item.scadenza = DateTime.fromISO(item.scadenza).toFormat('dd/MM/y')
            item.scadenzaRiduzione = DateTime.fromISO(item.scadenzaRiduzione).toFormat('dd/MM/y')
            options.push(item)
          })
          this.items = options
          this.items = this.items.sort(function (a, b) {
            return a.id - b.id
          })
        }).catch(error => {
          Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
        })
      } else {
        let config = this.urlForm()
        return axios(config).then((response) => {
          const options = []
          response.data.risorse.forEach((item) => {
            item.dataInfrazione = DateTime.fromISO(item.dataInfrazione).toFormat('dd/MM/y')
            item.scadenza = DateTime.fromISO(item.scadenza).toFormat('dd/MM/y')
            item.scadenzaRiduzione = DateTime.fromISO(item.scadenzaRiduzione).toFormat('dd/MM/y')
            options.push(item)
          })
          this.currentPage = this.currentPage + 1
          config = this.urlForm()
          return axios(config).then((response) => {
            response.data.risorse.forEach((item) => {
              item.dataInfrazione = DateTime.fromISO(item.dataInfrazione).toFormat('dd/MM/y')
              item.scadenza = DateTime.fromISO(item.scadenza).toFormat('dd/MM/y')
              item.scadenzaRiduzione = DateTime.fromISO(item.scadenzaRiduzione).toFormat('dd/MM/y')
              options.push(item)
            })
            this.items = options
            this.items = this.items.sort(function (a, b) {
              return a.id - b.id
            })
          }).catch(error => {
            Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
          })
        }).catch(error => {
          Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
        })
      }
    },
    resetFilters () {
      this.plateFilter = ''
      this.fromFilter = ''
      this.toFilter = ''
      this.paymentFilter = null
      this.disputeFilter = null
      this.refundFilter = null
      this.verificationFilter = null
      this.driverIdFilter = ''
      this.filtered = false
      this.$refs.penaltyChargeNotice.resetSearch()
    },
    getPaymentDisputeFilterString (filter) {
      if (filter) {
        return 'ESEGUITO'
      } return 'NON_ESEGUITO'
    },
    getVerificationFilterString (verificationFilter) {
      switch (verificationFilter) {
        case 0:
          return 'ACCETTATA'
        case 1:
          return 'NON_ACCETTATA'
        case 2:
          return 'DA_VERIFICARE'
      }
    },
    getRefundFilterString (refundFilter) {
      if (refundFilter) {
        return 'RICHIESTO'
      } return 'NON_RICHIESTO'
    },
    getDrivers () {
      return Vue.myGet(this, '/drivers', 'drivers').then((drivers) => {
        const editedDrivers = []
        const detailedDrivers = []
        editedDrivers.push({ value: '', text: drivers.length !== 0 ? this.$t('message.selectOption') : this.$t('message.noOption') })
        detailedDrivers.push({ value: '', text: drivers.length !== 0 ? this.$t('message.selectOption') : this.$t('message.noOption') })

        drivers.forEach(driver => {
          // eslint-disable-next-line no-unused-expressions
          editedDrivers.push({ text: `${driver.surname} ${driver.name}`, value: driver.id })
          detailedDrivers.push({ text: `${driver.surname} ${driver.name} - ${driver.taxCode}`, value: driver.id })
        })
        this.driverOptions = editedDrivers
        this.driverDetailedOptions = detailedDrivers
        return drivers
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
        return false
      })
    }
  }
}
</script>

<style scoped>
.my-color, .c-grey {
  color: darkgrey;
}
.c-green {
  color: #249a80 !important;
}

</style>
